/* eslint-disable no-template-curly-in-string */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as yup from 'yup';
import { getCurrentLanguage } from 'utils/translation';

import en from './en';
import es from './es';
import pt from './pt';

const resources = {
  'pt': {
    translation: pt,
  },
  'en': {
    translation: en,
  },
  'es': {
    translation: es,
  },
};

i18n
  .use(initReactI18next)
  .init({
    lng: getCurrentLanguage(),
    fallbackLng: 'en',
    resources,
  });

yup.setLocale({
  mixed: {
    notType: (_ref) => {
      switch (_ref.type) {
        case 'number':
          return 'ERROR.TYPE_NUMBER';
        case 'string':
          return 'ERROR.TYPE_STRING';
        default:
          return 'ERROR.TYPE_CUSTOM';
      }
    },
    required: 'ERROR.REQUIRED',
  },
  number: {
    positive: 'ERROR.POSITIVE',
    min: 'ERROR.MIN/${min}',
    max: 'ERROR.MAX/${max}',
    moreThan: 'ERROR.MORE_THAN/${value}'
  },
  string: {
    email: 'ERROR.EMAIL',
    min: 'ERROR.MIN_CHAR/${min}',
    max: 'ERROR.MAX_CHAR/${max}',
  },
});

export default i18n;
